import React from 'react';
import { Box, type SxProps, type Theme, Typography } from '@mui/material';
import { useBrand } from '@core/contexts/BrandContext';

export interface BrandLogoProps {
  variant: 'square' | 'horizontal';
  height: number;
  width: number | 'auto';
  sx?: SxProps<Theme>;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  variant,
  height,
  width,
  sx,
}) => {
  const { name, logo, logoHorizontal, logoSquare } = useBrand();
  const logoUrl = variant === 'square' ? logoSquare : (logoHorizontal ?? logo);

  if (logoUrl) {
    return (
      <Box
        sx={{
          width,
          height,
          backgroundColor: 'primary.main',
          maskImage: `url(${logoUrl})`,
          maskRepeat: 'no-repeat',
          maskSize: 'contain',
          maskPosition: 'center',
          WebkitMaskImage: `url(${logoUrl})`,
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskSize: 'contain',
          WebkitMaskPosition: 'center',
          ...sx,
        }}
      />
    );
  }

  return (
    <Typography
      component="div"
      sx={{
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${height / 50}rem`,
        fontWeight: 700,
        color: 'primary.main',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        userSelect: 'none',
        ...sx,
      }}
    >
      {variant === 'square' ? name.trim().charAt(0).toUpperCase() : name}
    </Typography>
  );
};

export default BrandLogo;
